const _ = require('lodash');
const FILTER_ENUM = require('./advance-filter/filter-type-enum');
/**
 * Handle filter operations
 * @class
 */

const FiltersService = function ($rootScope, $state, $stateParams, $timeout, Restangular, LocalStorageService
) {
    this._api = Restangular;
    this._localStorage = LocalStorageService;
    this.filters = [];
    this.seoTags = {};
    this.filterByGroups = [];
    this.appliedFilter = [];
    this.resultCount = 0;
    this.unavailableCount = 0;
    this.hideOutOfStockItems = this.getHideOutOfStockPreference();
    this.banners = [];
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
};

/**
 * @description - Customize API filter object
 * @function
 * @name initialise
 * @return {Object} - return customized filter object
 */
FiltersService.prototype.initialise = function (displayType) {
    const group = _.groupBy(this.filters, (filter) => {
        if (filter.DesignType === FILTER_ENUM.QUICK_FILTER_TEXT) {
            return 'quick';
        } else if (filter.DesignType === FILTER_ENUM.ADVANCE_FILTER_TEXT) {
            return 'advance';
        } else if (filter.DesignType.indexOf(displayType) !== -1) {
            if (filter.DesignType.indexOf(FILTER_ENUM.FILTER_TYPE_QUICK) !== -1) {
                return 'quick';
            }
            return 'advance';
        }
    });

    const filters = {
        quickFilters: group.quick,
        advanceFilters: group.advance
    };

    this.filterByGroups = filters;
    return filters;
};

/**
 * @description - Arrange filter by alphabetical order
 * @function
 * @name getAppliedFilters
 * @return {Object} - return applied filter
 */

FiltersService.prototype.groupByAlphabet = function (results) {
    const filter = {};

    const orderByName = _.sortBy(results, (o) => {
        return o.Name.toUpperCase();
    });

    _.each(orderByName, function (result) {
        const char = result.Name.charAt(0).toUpperCase();
        const alphabet = isNaN(char) ? char : '#';

        if (_.get(filter, alphabet) === undefined) {
            _.set(filter, alphabet, []);
        }

        filter[alphabet].push(result);
    });
    return filter;
};

/**
 * @description - Return URL processed filter object
 * @function
 * @name getAppliedFilters
 * @return {Object} - return applied filter
 */

FiltersService.prototype.getAppliedFilters = function () {
    this.appliedFilter = this.$stateParams.filters ?
        this.extractFiltersFromURL() : [];
    return this.appliedFilter;
};

/**
 * @description - Apply selected filter
 * @example
 * // FiltersService.applyFilter('brand', { Name: 'Ashai', Term: 'Ashai'}, 'Radio')
 * @param {String} filterName
 * @param {Object} filter
 * @param {String} type - FilterType
 * @function
 * @name applyFilter
 */

FiltersService.prototype.applyFilter = function (filterName, filter, type) {

    const index = _.findIndex(this.appliedFilter, (obj) => {
        return obj.Key === filterName;
    });

    if (index !== -1) {
        if (type === FILTER_ENUM.FILTER_RADIO) {
            this.appliedFilter[index].Items = [];
            this.appliedFilter[index].Items.push(filter);
        } else {
            const itemIndex = _.findIndex(this.appliedFilter[index].Items, filter);

            if (itemIndex === -1) {
                this.appliedFilter[index].Items.push(filter);
            } else {
                if (this.appliedFilter[index].Items.length === 1) {
                    this.appliedFilter.splice(index, 1); // If item array has only one item then remove parent object.
                } else {
                    this.appliedFilter[index].Items.splice(itemIndex, 1);
                }
            }
        }

    } else {
        this.appliedFilter.push({
            Key: filterName,
            Items: [filter]
        });
    }

    this.setFilterURL(); // Set fiter URL
};

FiltersService.prototype.clearFilter = function () {
    this.$state.go('.', {
        filters: null
    }, {
        notify: false
    });
    this.$timeout(() => { //Broadcast filter in next digest cycle
        this.$rootScope.$broadcast('filter:applied');
    });
};

/**
 * @description - configure filter URL
 * @example
 * // appliedFilter = { Key: 'brand', Items: [{ Term: 'chivas-salute'}]}
 * // filterURl = filters=brand(chivas-salute)
 * @function
 * @name setFilterURL
 */

FiltersService.prototype.setFilterURL = function () {

    let filterURL = '';

    _.each(this.appliedFilter, (filter) => {
        const filterKey = filter.Key;

        filterURL += filter.Key + '(';
        _.each(filter.Items, (item) => {

            if (item.Min !== undefined && item.Max !== undefined) {
                if (filterKey !== 'Customer-Rating') {
                    filterURL += '$' + item.Min + '-$' + item.Max + ',';
                } else {
                    filterURL += +item.Min + '-' + item.Max + ',';
                }
            } else {
                /**
                 * We need a way to differentiate a hyphenated word when
                 * we extract it from the URL on page reload, hence we firstly
                 * use a regex to match then replace with a '--' identifier.
                 */
                const matchHyphenatedWord = item.Term.match(/[a-zA-Z]+[-][a-zA-Z]+/g);

                if (matchHyphenatedWord) {
                    item.Term = item.Term.replace(/-/g, '--');
                }

                filterURL += item.Term.replace(/\s/g, '-')
                                      .concat(',');
            }
        });
        filterURL = filterURL.replace(/.$/, '),');
    });

    filterURL = filterURL.replace(/.$/, '');
    this.$state.go('.', {
        filters: filterURL,
        pageNumber: undefined
    }, {
        notify: false
    });
    this.$timeout(() => { //Broadcast filter in next digest cycle
        this.$rootScope.$broadcast('filter:applied');
    });
};

/**
 * @description - Helper function to return processed URL filter object
 * @example
 * // filters=brand(chivas-salute,dom-perignon),price($0-$10) - filters sepearted by comma (,)
 * //Filter group sepearted by {filterName}(vaue1,value2){filterName}(value1,value)..etc
 * @function
 * @name extractFiltersFromURL
 */

FiltersService.prototype.extractFiltersFromURL = function () {
    const filterGroup = this.$stateParams.filters.match(/[\w-]+\({1,1}[\w\W]+?\)/g);
    const filters = []; //Safe clear
    let urlAutoCorrection = ''; // Restrict wrong URL format

    _.each(filterGroup, (filter, index) => {
        urlAutoCorrection += filter;
        const filterValue = filter.split('(');
        const Key = filterValue[0]; //Set Filter value
        const value = filterValue[1].replace(/\(?\)/g, '').split(','); // Set Item values
        const Items = [];

        //Loop the item and set filter values
        _.each(value, (obj) => {
            if (obj.indexOf('$') !== -1 || Key === 'Customer-Rating') { // Filter price
                let price;

                if (obj.indexOf('$') !== -1) {
                    price = obj.replace(/\$/g, '').split('-');
                } else {
                    price = obj.split('-');
                }

                Items.push({
                    Min: price[0],
                    Max: price[1]
                });

            } else {
                Items.push({
                    Term: obj.replace(/-/g, ' ')
                             .replace(/\s{3}/g, ' - ') //e.g filter was originally 'thorn - clarke'
                             .replace(/\s{2}/g, '-') //e.g filter was originally 'thorn-clarke
                });
            }
        });

        if (filterGroup.length - 1 !== index) {
            urlAutoCorrection += ',';
        }

        filters.push({
            Key,
            Items
        });
    });

    if (this.$stateParams.filters !== urlAutoCorrection) {
        this.$state.go('.', {
            filters: urlAutoCorrection
        }, {
            notify: false
        });
    }

    return filters;
};

FiltersService.prototype.resetFilter = function () {
    this.filters = [];
    this.seoTags = {};
    this.filterByGroups = [];
    this.appliedFilter = [];
    this.resultCount = 0;
    this.banners = [];
};

FiltersService.prototype.getHideOutOfStockPreference = function () {
    return this._localStorage.getItem('hideOOSPreference') === 'true' ? true : false;
};
FiltersService.prototype.setHideOutOfStockPreference = function (value) {
    this.hideOutOfStockItems = value;
    this._localStorage.setItem('hideOOSPreference', value);
};

module.exports = FiltersService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/filters-service.js
 **/